var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSvb = function SvgSvb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6123_4459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.04689 7.97083C1.54146 7.87703 1.11003 7.79926 1.11003 7.41443C1.11003 7.09775 1.37125 6.90934 1.80565 6.90934C2.26446 6.90934 2.52494 7.1659 2.52494 7.61968H3.49363C3.49363 6.72976 2.86091 6.20703 1.80195 6.20703C0.742979 6.20703 0.0999025 6.69528 0.0999025 7.50824C0.0999025 8.49356 0.922063 8.63867 1.60954 8.75893C2.13125 8.85273 2.59746 8.93852 2.59746 9.3923C2.59746 9.75227 2.30516 9.95351 1.79899 9.95351C1.28097 9.95351 0.969424 9.6713 0.969424 9.19106H0C0 10.1291 0.666017 10.6767 1.80195 10.6767C2.93787 10.6767 3.60389 10.146 3.60389 9.26402C3.60389 8.25304 2.75065 8.09911 2.04985 7.97083",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63809 10.1806H5.62625L4.71973 6.29297H3.60156L4.75747 10.5911H6.50761L7.66352 6.29297H6.54461L5.63809 10.1806Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97591 9.79489C9.50452 9.79489 9.17669 9.49665 9.04127 9.0108C8.99331 8.83189 8.96988 8.64631 8.97171 8.46001C8.97058 8.27824 8.99401 8.09727 9.04127 7.92286C9.16633 7.46908 9.46604 7.11552 9.97591 7.11552C10.7359 7.11552 10.9794 7.78095 10.9794 8.46001C10.9794 9.24892 10.6449 9.79489 9.97591 9.79489ZM10.3074 6.22079C10.0382 6.21103 9.77268 6.29179 9.54744 6.45199C9.3222 6.61218 9.14824 6.84396 9.04941 7.11552H9.03757V4H7.99414V10.5934H8.65868L9.04423 9.83979H9.05607C9.17063 10.0955 9.34944 10.3111 9.57197 10.4617C9.79449 10.6123 10.0517 10.6919 10.3141 10.6912C11.3723 10.7073 12.0531 9.77325 12.0531 8.45681C12.0531 7.11632 11.4219 6.22159 10.3141 6.22159",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3502 4.88672L12.5273 5.43991L14.0865 8.44318L12.5273 11.4464L13.3502 11.9996L16.0009 8.44318L13.3502 4.88672Z",
    fill: "#00C0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6123_4459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSvb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "SVB.48e3c350a5894fd8634e192159bde6fd.svg";